import styles from "./Company.module.css"
import Banner from "../../components/Banner"
import Header from "../../components/Header"
import Container from "../../components/Container"
import Team from "../../components/Team"
import Footer from "../../components/Footer"
import TitlePages from "../../components/TitlePages"
import videoCompany from "./video-company.m4v"

function Company() {

    const projects = [
        {
            id: 1,
            name: "Game Development:",
            text: "Designing and developing engaging games with a strong focus on gameplay, performance, and player experience.",
            className: styles.game
        },
        {
            id: 2,
            name: "Web3 Development:",
            text: "Integrating Web3 technologies into games and digital products when decentralized features.",
            className: styles.globe
        },
        {
            id: 3,
            name: "Digital Assets & Payments:",
            text: "Implementing digital asset and payment systems to support in-game economies and online products.",
            className: styles.crypto
        },
        {
            id: 4,
            name: "Blockchain Solutions:",
            text: "Building backend and distributed systems to support scalable games and digital platforms, with blockchain.",
            className: styles.blockchain
        },   
    ]

    return(
        <>
            <Header />
            <Banner 
                videoSrc={videoCompany}
                title="Innovating the <span>future</span> <br> with Web3."
                subtitle="engiforge.dev is the development arm focused on building games <br> and digital products, enhanced with modern technologies <br> such as Web3 and blockchain."
            />
            <Container>
                <TitlePages 
                    title="Our expertise, your <br/> next big <span>project<span>."
                    subTitle="Unlock the future with our expertise in gaming <br> development, Web3 and blockchain"
                />

                <section className={styles.projects}>
                    {projects.map((project) => (
                        <div key={project.id} className={styles.card}>
                            <div className={styles.icon}> <span className={project.className}></span> </div>
                            <h2>{project.name}</h2>
                            <p>{project.text}</p>
                        </div>

                    ))}   
                </section>
            </Container>
            <Team />
            <Footer />
        </>
    )
}

export default Company
